<template>
  <div id="hello-background"></div>
</template>

<script>
export default { name: 'HelloBackground' };
</script>

<style scoped lang="scss">
  #hello-background {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100vh;

    background-image: url("../../assets/backgrounds/bg-main.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    filter: brightness(55%);
  }
</style>
